/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, December 2021
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import Select from 'react-select';
import { Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import CustomizedMap from './CustomizedMap';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import { PanelStyle } from '../../constants';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';

import loadingData from './loading';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};


const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
  type,
} = PanelStyle;

const paymentMessage = 'Wybrany grób nie wymaga przedłużenia dzierżawy, ponieważ jest to grób murowany położony w kwaterze pieczarowej.'

const graveyard10Options = [
  {
    label: '',
    value: null,
    state: 'kwota',
  },
];

const graveyard11Options = [
  {
    label: '',
    value: null,
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym pojedynczym osoby dorosłej – 300 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym pojedynczym osoby dorosłej – 300 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym dwupoziomowym osoby dorosłej – 400 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym dwupoziomowym osoby dorosłej – 400 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie  dzierżawy na dalsze 20 lat miejsca pod grobem dla urn – 200 zł',
    value: 'przedłużenie  dzierżawy na dalsze 20 lat miejsca pod grobem dla urn – 200 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym dziecka do lat 6 – 100 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym dziecka do lat 6 – 100 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy – 400 zł',
    value: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy – 400 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy dwupoziomowy – 500 zł',
    value: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy dwupoziomowy – 500 zł',
    state: 'kwota',
  },
];

const graveyard2Options = [
  {
    label: '',
    value: null,
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym pojedynczym osoby dorosłej – 300 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym pojedynczym osoby dorosłej – 300 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym dwupoziomowym osoby dorosłej – 400 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat  miejsca pod istniejącym grobem ziemnym dwupoziomowym osoby dorosłej – 400 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie  dzierżawy na dalsze 20 lat miejsca pod grobem dla urn – 200 zł',
    value: 'przedłużenie  dzierżawy na dalsze 20 lat miejsca pod grobem dla urn – 200 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym dziecka do lat 6 – 100 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym dziecka do lat 6 – 100 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy – 400 zł',
    value: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy – 400 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy dwupoziomowy – 500 zł',
    value: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat pod grób ziemny pojedynczy dwupoziomowy – 500 zł',
    state: 'kwota',
  },
];


const graveyard3Options = [
  {
    label: '',
    value: null,
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym osoby dorosłej – 400 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym osoby dorosłej – 400 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym dziecka do lat 6 – 100 zł',
    value: 'przedłużenie dzierżawy na dalsze 20 lat miejsca pod istniejącym grobem ziemnym dziecka do lat 6 – 100 zł',
    state: 'kwota',
  },
  {
    label: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat – 1000 zł',
    value: 'przedłużenie rezerwacji za miejsce grzebalne na dalsze 20 lat – 1000 zł',
    state: 'kwota',
  },
];

const graveyardDict = {
  2815083: {
    'Cmentarz Dury': [graveyard10Options, graveyard11Options],
    'Cmentarz Antoniewo': graveyard2Options,
    'Cmentarz Komunalny w Morągu': graveyard3Options,
  },
};

const GraveDict = {
  imieINazwisko: {
    label: 'Imię i nazwisko zmarłego:',
    editable: true,
  },
  dataZgonu: {
    label: 'Data zgonu:',
    editable: true,
  },
  nazwaCmentarza: {
    label: 'Nazwa cmentarza:',
    editable: true,
  },
  numerSektora: {
    label: 'Numer sektora:',
    editable: true,
  },
  numerRzedu: {
    label: 'Numer rzędu:',
    editable: true,
  },
  numerGrobu: {
    label: 'Numer grobu:',
    editable: true,
  },
};

const InfoTypeDict = {
  dowod: {
    label: 'Seria i nr dowodu osobistego**:',
    editable: true,
  },
  pokrewienstwo: {
    label: 'Pokrewieństwo do osoby pochowanej:',
    editable: true,
  },
};


class OplataZaDzierzaweMiejscaGrzebalnego extends React.Component {
  state = {
    showMore: false,
    optionsGraveyard: null,
    choosenGraveyard: null,
    choosenGraveyardName: null,
    uzytkownikGrobu: null,
    grobyTabela: null,
    searchText: '',
    images: [],
    info: {
      dowod: null,
      pokrewienstwo: null,
      imieINazwisko: null,
      dataUrodz: null,
      dataZgonu: null,
      nazwaCmentarza: null,
      numerSektora: null,
      numerRzedu: null,
      numerGrobu: null,
      kwota: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    attachments: null,
    loading: false,
    downloadFile: false,
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    mapCenter: null,
    zoom: 12,
  };

  validators = {
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });

    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    this.fetchGraveyard();
  }

  fetchGraveyard = () => {
    fetch(`${process.env.API_URL}/cmentarze/${this.props.prefix}/cmentarze`)
    .then(r => r.json())
    .then(resp => {
      this.setState({ optionsGraveyard: resp });
    });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChangePaymentSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    if (callback) {
      if (this.state.downloadFile) {
        this.validators = {};
      } else {
        this.validators = {
          dowod: [v.NotNull],
          pokrewienstwo: [v.NotNull],
          imieINazwisko: [v.NotNull],
          dataZgonu: [v.NotNull],
          nazwaCmentarza: [v.NotNull],
          numerSektora: [],
          numerRzedu: [],
          numerGrobu: [],
          kwota: [],
        };
        if (this.state.uzytkownikGrobu && this.state.uzytkownikGrobu.nr_ewid_sektor) {
          this.validators.numerSektora = [v.NotNull];
        }
        if (this.state.uzytkownikGrobu && this.state.uzytkownikGrobu.nr_ewid_rzad) {
          this.validators.numerRzedu = [v.NotNull];
        }
        if (this.state.uzytkownikGrobu && this.state.uzytkownikGrobu.nr_ewid_grob) {
          this.validators.numerGrobu = [v.NotNull];
        }
      }
    }
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const teryt = this.props.districts[this.props.prefix].teryt;
    if (teryt === 2815083) {
      if (this.state.choosenGraveyardName === 'Cmentarz Dury' && ['II pieczarowy', 'III pieczarowy'].includes(this.state.info.numerSektora)) {
        this.setState({
          errorText: paymentMessage,
          errorTitle: 'Przedłużenie dzierżawy niewymagane.',
          showError: true,
          loading: false,
        });
        return;
      }
    }

    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: [],
          selectedParcels: [],
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    if (!this.state.downloadFile) {
      window.location.href = `${this.nextStep}${jobId}`;
    } else {
      window.location.href = `${process.env.API_URL}/eservices/getJobApplication/${jobId}`;
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  handleChange = (obj) => {
    const cordsX = [];
    const cordsY = [];
    obj.geometry.coordinates[0].map((v, i) => {
      cordsX.push(v[0]);
      cordsY.push(v[1]);
    });

    Array.prototype.max = function() {
      return Math.max.apply(null, this);
    };

    Array.prototype.min = function() {
      return Math.min.apply(null, this);
    };

    const maxX = cordsX.max();
    const maxY = cordsY.max();
    const minX = cordsX.min();
    const minY = cordsY.min();

    const mapCenter = [(minY + ((maxY - minY) / 2)), (minX + ((maxX - minX) / 2))];

    this.setState({
      showMore: true,
      choosenGraveyard: obj.properties.id,
      choosenGraveyardName: obj.properties.nazwa,
      uzytkownikGrobu: null,
      grobyTabela: null,
      searchText: '',
      mapCenter,
      zoom: 18,
    });
  }

  changeSearchEngine = (str) => {
    const imienazw = str.target.value;
    this.setState({
      searchText: imienazw,
    });
  }

  searchGraves = () => {
    fetch(`${process.env.API_URL}/cmentarze/${this.props.prefix}/znajdz/groby?imienazw=${this.state.searchText}&id_cmentarz=${this.state.choosenGraveyard}`)
    .then(resp => {
      return resp.json();
    })
    .then(resp => {
      this.setState({
        grobyTabela: resp,
      });
    })
    .catch(err => console.error(err));
  }

  chooseGrave = (e, latlng = false) => {
    let url = '';
    if (!latlng) {
      const idGrobu = e.target.value;
      url = `${process.env.API_URL}/cmentarze/${this.props.prefix}/grob?idzmarlego=${idGrobu}`;
    } else {
      url = `${process.env.API_URL}/cmentarze/${this.props.prefix}/grob?lat=${e.latlng.lat}&lng=${e.latlng.lng}`;
    }
    fetch(url)
    .then(resp => {
      return resp.json();
    })
    .then(resp => {
      const info = this.state.info;
      info.imieINazwisko = `${resp.imie ? resp.imie : 'brak imienia'} ${resp.nazwisko ? resp.nazwisko : 'brak nazwiska'}`;
      info.nazwaCmentarza = this.state.choosenGraveyardName;
      info.numerSektora = resp.nr_ewid_sektor;
      info.numerRzedu = resp.nr_ewid_rzad;
      info.numerGrobu = resp.nr_ewid_grob;
      info.dataZgonu = resp.data_zgonu ? resp.data_zgonu[0] : 'brak danych';
      info.dataUrodz = resp.data_urodzenia ? resp.data_urodzenia[0] : 'brak danych';
      info.kwota = null;
      const mapCenter = [resp.lat, resp.lng];
      this.setState({
        uzytkownikGrobu: resp,
        info,
        mapCenter,
        zoom: 22,
      }, () => {
        this.getImages(resp.PK_UID);
      });
    })
    .catch(err => {
      console.error(err);
      this.setState({
        uzytkownikGrobu: null,
      });
    });
  }

  getImages = (graveId) => {
    const url = `${process.env.API_URL}/zdjecie_grobu/${this.props.prefix}/${graveId}`;
    fetch(url, {
      type: 'GET',
    })
    .then(resp => {
      return resp.json();
    })
    .then(resp => {
      const images = [];
      if(resp.imagesExists) {
        resp.images.map((v) => {
          images.push({ src: `${process.env.API_URL}/zdjecie_grobu/${this.props.prefix}/${graveId}/${v}`});
        });
      }
      this.setState({
        images: {
          imagesExists: resp.imagesExists,
          images,
          thumb: resp.thumb,
        },
      });
    })
    .catch(err => {
      console.error(err);
      this.setState({
        images: null,
      });
    });
  }

  getPaymentSelectWithError = (group, field) => {
    let options = [];
    let showPaymentInfo = false;
    const teryt = this.props.districts[this.props.prefix].teryt;
    if (teryt === 2815083) {
      if (this.state.choosenGraveyardName === 'Cmentarz Dury') {
        if (['II pieczarowy', 'III pieczarowy'].includes(this.state.info.numerSektora)) {
          options = graveyardDict[teryt][this.state.choosenGraveyardName][0];
          showPaymentInfo = true;
        } else {
          options = graveyardDict[teryt][this.state.choosenGraveyardName][1];
        }
      } else {
        options = graveyardDict[teryt][this.state.choosenGraveyardName];
      }
    }
    return (
      <div className="row mobile-row" style={rowStyle}>
        <div className={leftCol} />
        <div className={labelCol}>
          <p><b>Kwota do zapłaty*:</b></p>
        </div>
        <div className={inputCol}>
          <Select
            noResultsText={'brak wyników'}
            clearable={false}
            options={options}
            value={this.state[group][field]}
            placeholder={'Wybierz z listy...'}
            onChange={e => this.onChangePaymentSelect(e, group)}
            style={{
              width: '100%',
              borderColor:
                Object.keys(this.state.errors).indexOf(`${field}`) > -1 &&
                  this.state.errors[`${field}`] !== null &&
                  this.state.errors[`${field}`].length > 0
                  ? 'red'
                  : '#ccc',
            }}
            onBlur={event => event.preventDefault()}
            optionClassName="needsclick"
            blurInputOnSelect={false}
          />
          {/* RENDER ERROS IN SPAN */}
          {Object.keys(this.state.errors).indexOf(`${field}`) > -1 &&
            this.state.errors[`${field}`] !== null &&
            this.state.errors[`${field}`].length > 0
            ? this.state.errors[`${field}`].map((val, index) => (
              <span key={index} style={errorSpanStyle}>
                {val}
              </span>
            ))
            : null}

          {showPaymentInfo ?
            <p style={errorSpanStyle}><b>{paymentMessage}</b></p>
          : null}
          <div className={rightCol} />
        </div>
      </div>
    );
  }

  tableData() {
    const tableForLabel = [
      { 'Imię:': this.state.uzytkownikGrobu.imie ? this.state.uzytkownikGrobu.imie : 'brak imienia' },
      { 'Nazwisko:': this.state.uzytkownikGrobu.nazwisko ? this.state.uzytkownikGrobu.nazwisko : 'brak nazwiska' },
      { 'Data śmierci:': this.state.uzytkownikGrobu.data_zgonu ? this.state.uzytkownikGrobu.data_zgonu : 'brak danych' },
      { 'Data urodzenia:': this.state.uzytkownikGrobu.data_urodzenia ? this.state.uzytkownikGrobu.data_urodzenia : 'brak danych' },
      { 'Wiek:': this.state.uzytkownikGrobu.wiek ? this.state.uzytkownikGrobu.wiek : 'brak danych' },
      { 'Nr sektora:': this.state.uzytkownikGrobu.nr_ewid_sektor },
      { 'Nr rzędu:': this.state.uzytkownikGrobu.nr_ewid_rzad },
      { 'Nr grobu:': this.state.uzytkownikGrobu.nr_ewid_grob },
    ];

    return tableForLabel.map((v, i) => {
      const klucz = Object.keys(v);
      const wartosc = v[klucz] ? v[klucz] : '-';
      return (
        <tr key={v + i} className={(i + 1) % 2 === 1 ? 'background_table_zmarly' : ''}>
          <td className="table_zmarly"><strong>{klucz}</strong></td>
          <td className="table_zmarly">{wartosc}</td>
        </tr>
      );
    });
  }

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel title={'1. Wybór grobu'} >
          <div className="cmentarze-main">
            <div className="row">
              <label htmlFor="graveyardSelection" style={{ fontSize: '18px' }}>Wybierz cmentarz:</label>
            </div>
            <div className="row">
              {this.state.optionsGraveyard ? this.state.optionsGraveyard.features.map(v => {
                return (
                  <div className="col-md-4" key={`graveyard_${v.properties.id}`}>
                    <button className={this.state.choosenGraveyard === v.properties.id ? 'btn-block cmentarze_button cmentarze_active' : 'btn-block cmentarze_button'} onClick={() => this.handleChange(v)} style={this.state.style}>{v.properties.nazwa}</button>
                  </div>
                );
              }) : null}

            </div>

            <CustomizedMap
              serviceType={this.props.serviceInfo.eservice.shortName}
              setParcels={this.setParcels}
              setSelectDzialki={this.setSelectDzialki}
              selectedParcels={this.state.selectedParcels}
              obreby={this.props.serviceInfo.precints}
              district={this.props.districts[this.props.prefix]}
              prefix={this.props.prefix}
              mapState={this.props.mapstates[0]}
              settings={this.props.serviceInfo.eservice.mapConfig}
              dokumentType={this.props.serviceInfo.eservice}
              mapCenter={this.state.mapCenter}
              zoom={this.state.zoom}
              wybranyGrob={{
                data: this.state.info,
                images: this.state.images,
              }}
              showPopup={(this.state.uzytkownikGrobu !== null)}
              chooseGrave={this.chooseGrave}
            />

            {this.state.showMore ?
              <div>
                <div className="form-group">
                  <label htmlFor="select" style={{ fontSize: '18px' }}>Wyszukaj po imieniu, nazwisku lub dacie zgonu:</label>
                  <Col xs={10} style={{ display: 'flex', justifyContent: 'center' }}>
                    <input
                      placeholder="np.: Imię Nazwisko 01.01.1900"
                      onChange={(e) => this.changeSearchEngine(e)}
                      type="text"
                      className="form-control cmentarze_area"
                      style={{ padding: '20px', fontSize: '24px', lineHeight: '24px' }}
                      value={this.state.searchText}
                    />
                  </Col>
                  <Col xs={2} >
                    <button
                      type="submit-lg"
                      className={this.state.searchText ? 'btn btn-primary' : 'btn btn-primary disabled'}
                      style={{ float: 'right', ...btnStyle, ...this.state.style }}
                      onClick={() => this.searchGraves()}
                    >
                      Wyszukaj
                    </button>
                  </Col>

                  {/* <span className="fa fa-search fa-3x searchInputIcon" /> */}
                </div>
                <div className="form-group graves-info-list" style={{ width: '100%', marginTop: '20px' }}>
                  <label htmlFor="listaZmarlych" style={{ fontSize: '18px' }}>Następnie wybierz zmarłego z listy:</label>
                  <select onChange={(e) => this.chooseGrave(e)} size={this.state.grobyTabela !== null && this.state.grobyTabela.length < 5 ? this.state.grobyTabela.length + 1 : '5'  } className="form-control groby-select cmentarze_area" name="listaZmarlych">
                    {this.state.grobyTabela !== null && this.state.grobyTabela.length === 0 ? <option>brak wyników</option> : null}
                    {(this.state.grobyTabela !== null) ? this.state.grobyTabela.map((v, i) => {
                      return (
                        <option key={v + i} value={v.id} style={{ padding: '5px 0', fontSize: '25px' }}>
                          &#10014; {v.nazwisko} {v.imie} zm. {v.data_zgonu}
                        </option>
                      );
                    }) : null}
                  </select>
                  {this.state.uzytkownikGrobu ?
                    <div className="graves-info-list" style={{ width: '100%', marginTop: '20px' }}>
                      <table>
                        {this.tableData()}
                      </table>
                    </div>
                  : null }
                </div>
              </div> : null }

          </div>
        </GrayPanel>

        <DecisionContainer
          title={'2. Informacje o zmarłym'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={GraveDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        >
          {this.getPaymentSelectWithError('info', 'kwota')}
          <div className="row mobile-row" style={rowStyle}>
            <div className={leftCol} />
            <div className="col-sm-10">
              <p><b>* Jeśli nie jesteś pewien jaką opłatę wybrać, to pozostaw to pole puste
                lub skontaktuj się z zarządcą cmentarza (Przedsiębiorstwo Oczyszczania)
                w celu ustalenia wysokości opłaty.</b>
              </p>
            </div>
          </div>
        </DecisionContainer>

        <DecisionContainer
          title={'3. Informacje dodatkowe'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        >
          <div className="row mobile-row" style={rowStyle}>
            <div className={leftCol} />
            <div className="col-sm-10">
              <p><b>** Konieczne będzie osobiste okazanie dowodu osobistego u zarządcy cmentarza w celu potwierdzenia tożsamości dysponenta grobu.</b>
              </p>
            </div>
          </div>
        </DecisionContainer>
        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'left', ...btnStyle }}
              onClick={() => this.setState({ loading: true, downloadFile: true }, () => this.startService())}
            >
              Pobierz wersję do druku i dostarcz osobiście do zarządcy cmentarza
            </button>
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true, downloadFile: false }, () => this.startService())}
            >
              Podpisz elektronicznie i prześlij do zarządcy cmentarza
            </button>
          </div>
          <div className="col-sm-12" style={{ marginTop: '20px' }}>
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

OplataZaDzierzaweMiejscaGrzebalnego.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(OplataZaDzierzaweMiejscaGrzebalnego),
);



// WEBPACK FOOTER //
// src/routes/eservices/OplataZaDzierzaweMiejscaGrzebalnego.js